// extracted by mini-css-extract-plugin
module.exports = {"content":"index_content__KKOiB","title":"index_title__JJPgz","desc":"index_desc__9S9da"};